import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { selectEventsData } from "../events/eventsSlice";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";
import UIButton from "../../UI/UIButton";
import HeaderLogo from "../../UI/HeaderLogo";


export const FactWrapper = styled.div`
  width: 100vw;
  height: 100dvh;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding: 0 5px;
  max-width: 343px;
  margin: 0 auto;
`;

const TitleText = styled.div`
  color: #323232;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  max-width: 300px;
  text-align: center;
  white-space: pre-line;
  ${({ $bigText }) =>
    $bigText &&
    css`
      font-size: 64px;
      line-height: 83.2px;
      font-weight: 700;
    `}
`;

const FactText = styled.div`
  margin: 12px 0 16px;
  max-width: 290px;
  color: #323232;
  font-size: 16px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: -0.128px;
  text-align: center;
  white-space: pre-line;
  > span {
    font-weight: 700;
  }
`;

const FactContainer = ({
  history,
  factTitle,
  factDescription,
  nextUrl,
  screenName,
  bigText = false,
}) => {
  const eventsData = useSelector(selectEventsData);
  const onContinueClick = () => {
    sendAnalyticsEvents(EVENTS.onboardingFactPageSubmitted, {
      ...eventsData,
      screen_name: screenName,
    });
    history.push(`/${nextUrl}`);
  };
  return (
    <FactWrapper>
      <HeaderLogo />
      <TextWrapper>
        <TitleText $bigText={bigText}>{factTitle}</TitleText>
        <FactText dangerouslySetInnerHTML={factDescription} />
      </TextWrapper>
      <UIButton
        onClick={onContinueClick}
        bottomPosition={'24px'}
        position={'sticky'}
        customBeforeBg="none"
        displayStubBtn={false}
        customBeforeHeight={'0px'}
        customMargin={'0px 16px'}
        customStyles={'min-height:56px'}
      />
    </FactWrapper>
  );
};

export default FactContainer;
